import { Component, Inject, Input } from '@angular/core';
import { PurchasedProductInterface } from 'outshared-lib';
import { WINDOW } from '@inshared/shared/util';

const TEST_SERVER = 'insh-nl-frontend-website.test.outshared-staging.services';

@Component({
    selector: 'ins-insurance-list-related-vehicle',
    templateUrl: 'insurance-list-related-vehicle.component.html',
    styleUrls: [ 'insurance-list-related-vehicle.component.scss' ],
})
export class InsuranceListRelatedVehicleComponent {
    public isTest: boolean;
    @Input() public purchasedProduct!: PurchasedProductInterface;

    constructor(
        @Inject(WINDOW) private window: Window,
    ) {
        // For testing purposes
        this.validateTestEnvironment();
    }

    private validateTestEnvironment(): void {
        const windowLocation: string = this.window.location.href.toString();

        if (windowLocation.includes(TEST_SERVER)) {
            this.isTest = true;
        } else {
            this.isTest = false;
        }
    }
}
